/**
 * =====================================================
 * menu.js
 * =====================================================
 *
 * Progetto: Ventura Shop
 * Tipo: Satellite JS
 * Dipendenza: main.js (namespace globale "ventura")
 *
 * Descrizione:
 * Questo file contiene tutte le logiche JS specifiche
 * dei menu. Si integra con il namespace
 * globale "ventura" definito in main.js.
 *
 * Note:
 * - Non dipendere da altri satelliti, solo da main.js
 * - Il caricamento condizionale avviene tramite la
 *   variabile globale `isTemplate` passata da PHP
 *   tramite WP_PARAMS.is_page_template.
 * - Tutte le funzioni dovrebbero essere incapsulate
 *   all'interno di ventura o di closure locali.
 *
 * Esempio di utilizzo:
 *   ventura.cartInit();
 *
 * =====================================================
 */
window.ventura = window.ventura || {};

(function($) {

    ventura.menuMobileEng = () => {
        var $body = $('body');
        var $hamburger = $('.hamburger-eng');
        var $menuContainer = $('.menu-main-container');
        var $closeBtn = $('.close-header-nav');
        var $showcaseImgs = $('.showcase-items__media img');

        // Toggle menu principale
        $hamburger.on('click', function() {
            $menuContainer.slideToggle(550);

            if ($body.hasClass('menu_aperto')) {
                $body.removeClass('menu_aperto');
            } else {
                $body.addClass('menu_aperto');
                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({ id: 'menuop' });
                }
            }

            // Gestione menu mobile aperto/chiusura
            if ($body.hasClass('menu_mobile_aperto')) {
                $body.addClass('menu_mobile_closing');
                setTimeout(function() {
                    $body.removeClass('menu_mobile_closing menu_mobile_aperto');
                }, 500);
            } else {
                $body.addClass('menu_mobile_aperto');
            }
        });

        // Pulsante di chiusura menu
        $closeBtn.on('click', function() {
            if ($body.hasClass('menu_mobile_aperto')) {
                $body.addClass('menu_mobile_closing');
                setTimeout(function() {
                    $body.removeClass('menu_mobile_closing menu_mobile_aperto');
                }, 500);
            }
        });

        // Listener resize
        $(window).on('resize', function() {
            if (ventura.onResize) ventura.onResize();
            if (ventura.customCookieText) ventura.customCookieText();

            if ($(window).width() < 768) {
                $showcaseImgs.css('border-radius', '0px');
            } else {
                $showcaseImgs.css('border-radius', '6px');
            }
        });
    };

    ventura.menuMagazine = () => {
        var $body = $('body');
        var $hamburger = $('.hamburger');
        var $menuContainer = $('.menu-main-container');

        $hamburger.on('click', function() {
            // Toggle visibilità menu
            $menuContainer.slideToggle(550);

            // Gestione classe menu_aperto
            if ($body.hasClass('menu_aperto')) {
                $body.removeClass('menu_aperto');
            } else {
                $body.addClass('menu_aperto');

                // Push su dataLayer se definito
                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push({ id: 'menuop' });
                }
            }
        });
    };

    ventura.menuMobile = () => {
        const $body = document.body;
        const navElement = document.getElementById("hamburger");
        if (!navElement) return; // Esci se non c'è il menu

        // --- Multilevel mobile menu ---
        const navExpandItems = Array.from(document.querySelectorAll(".nav-expand"));
        const backLinkHTML = `
            <li class="nav-item nav-back-item">
                <a class="nav-link nav-back-link" href="javascript:;">Indietro</a>
            </li>
        `;

        navExpandItems.forEach(item => {
            const expandContent = item.querySelector(".nav-expand-content");
            const navLink = item.querySelector(".nav-link");
            const backLink = item.querySelector(".nav-back-link");

            expandContent.insertAdjacentHTML("afterbegin", backLinkHTML);

            navLink.addEventListener("click", () => item.classList.add("active"));
            backLink.addEventListener("click", () => item.classList.remove("active"));
        });

        // Toggle menu principale
        const ham = navElement;
        const hamClose = document.getElementById("nav-close");

        if (ham) ham.addEventListener("click", () => $body.classList.toggle("nav-is-toggled"));
        if (hamClose) hamClose.addEventListener("click", () => $body.classList.toggle("nav-is-toggled"));

        // Resize window
        window.addEventListener("resize", () => {
            // --- FUNZIONI ESTERNE ---
            if (typeof ventura !== "undefined" && typeof ventura.onResize === "function") {
                ventura.onResize();
            }

            $(".showcase-items__media img").css(
                "border-radius",
                window.innerWidth < 768 ? "0px" : "6px"
            );
        });
    };

    // Document ready per satellite
    $(document).ready(function() {
        //ventura.menuMobileEng();
        //ventura.menuMagazine();
        //ventura.menuMobile();
    });

})(jQuery);